import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, CheckCircle2, ArrowRight, FileText, TrendingUp, DollarSign } from 'lucide-react';
import { servicesData } from '../data/mockData';

const GuidesPage = () => {
  // Filter services that have "Guide" in the title OR is the Affidavit Former Tool
  const guideServices = servicesData.filter(service => 
    service.title.toLowerCase().includes('guide') || 
    service.title.toLowerCase().includes('affidavit')
  );

  return (
    <div className="dark-page tradelines-page">
      {/* Hero Section */}
      <section className="tradelines-hero">
        <div className="tradelines-hero-content">
          <div className="tradelines-badge">KNOWLEDGE & RESOURCES</div>
          <h1 className="display-huge tradelines-title">
            DIY <span className="text-gradient">Guides & Resources</span>
          </h1>
          <p className="body-large tradelines-subtitle">
            Take control of your financial future with our comprehensive step-by-step guides. 
            Learn proven strategies and execute them at your own pace.
          </p>
          
          <div className="tradelines-features-row">
            <div className="tradeline-feature-item">
              <BookOpen size={24} />
              <span>Step-by-Step Instructions</span>
            </div>
            <div className="tradeline-feature-item">
              <FileText size={24} />
              <span>Templates Included</span>
            </div>
            <div className="tradeline-feature-item">
              <TrendingUp size={24} />
              <span>Proven Strategies</span>
            </div>
          </div>
        </div>
      </section>

      {/* Value Banner */}
      <div className="guarantee-banner">
        <div className="guarantee-content">
          <DollarSign size={24} />
          <p>Affordable DIY solutions — save thousands by doing it yourself with expert guidance</p>
        </div>
      </div>

      {/* Guides Grid */}
      <section className="tradelines-grid-section">
        <div className="section-header">
          <h2 className="display-medium section-title">Available Guides</h2>
          <p className="body-medium section-description">
            Choose a guide and start your journey to financial empowerment
          </p>
        </div>
        
        <div className="tradelines-grid">
          {guideServices.map((guide) => (
            <div key={guide.id} className="tradeline-card" data-testid="guide-card">
              <div className="tradeline-card-header">
                <h3 className="tradeline-card-title">{guide.title}</h3>
              </div>
              
              <p className="tradeline-card-description">{guide.description}</p>
              
              <ul className="tradeline-card-features">
                {guide.features.slice(0, 6).map((feature, idx) => (
                  <li key={idx} className="tradeline-feature">
                    <CheckCircle2 size={16} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <div className="tradeline-card-footer">
                {guide.paymentLink ? (
                  <a 
                    href={guide.paymentLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="btn-primary tradeline-buy-btn"
                    data-testid="guide-buy-btn"
                  >
                    Learn More
                    <ArrowRight size={18} />
                  </a>
                ) : (
                  <Link to="/contact" className="btn-secondary tradeline-apply-btn">
                    Learn More
                    <ArrowRight size={18} />
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="tradelines-cta-section">
        <div className="tradelines-cta-content">
          <h2 className="display-medium">Need Personalized Help?</h2>
          <p className="body-large">
            If you'd prefer hands-on assistance instead of DIY, book a consultation 
            and we'll handle everything for you.
          </p>
          <a 
            href="https://calendly.com/thecollinsacademynew/30min" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-primary"
          >
            Schedule Consultation
            <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default GuidesPage;
